import { useEffect, useState } from "react";
import { Navigate, useParams } from "react-router-dom";
import { getRentalByBooking } from "../../api/workspaceRentals";
import { useAuth } from "../../context/AuthContext";
import MarketplaceShell from "./MarketplaceShell";

export default function MarketplaceRentalSummaryRedirectPage() {
  const { bookingId } = useParams();
  const { token } = useAuth();
  const [targetRentalId, setTargetRentalId] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!token || !bookingId) return;
    let active = true;
    setError("");
    getRentalByBooking(bookingId, token)
      .then((row) => {
        if (active) setTargetRentalId(row?.id || null);
      })
      .catch((err) => {
        if (active) {
          setError(err.message || "Unable to resolve the canonical rental summary.");
        }
      });
    return () => {
      active = false;
    };
  }, [bookingId, token]);

  if (targetRentalId) {
    return <Navigate to={`/account/rentals/${targetRentalId}`} replace />;
  }

  return (
    <MarketplaceShell>
      <section className="mx-auto max-w-3xl rounded-[2rem] border border-slate-200 bg-white p-8 shadow-sm">
        <p className="text-xs font-semibold uppercase tracking-[0.22em] text-rose-500">
          Rental Summary
        </p>
        <h1 className="mt-3 text-2xl font-semibold text-slate-950">
          Resolving your canonical rental record
        </h1>
        <p className="mt-3 text-sm leading-7 text-slate-600">
          This compatibility route maps the older booking reference onto the canonical
          Ellyanna Boothshare rental summary.
        </p>
        {error ? (
          <div className="mt-5 rounded-2xl border border-rose-200 bg-rose-50 px-4 py-3 text-sm text-rose-700">
            {error}
          </div>
        ) : (
          <div className="mt-5 text-sm text-slate-600">Loading rental summary...</div>
        )}
      </section>
    </MarketplaceShell>
  );
}
